import React from "react";

function ProductTop(props) {
    return (
        <div className="flex items-center space-x-4">
            <img
                className="w-12 h-12 rounded-lg object-cover"
                src={props.image}
                alt={props.name}
            />
            <div className="flex-1">
                <p className="font-medium text-gray-800">{props.name}</p>
                {/*<p className="text-sm text-gray-500">47 sales this month</p>*/}
            </div>
            <p className="font-semibold text-custom-green">{props.price}</p>
        </div>
    );

}
export default ProductTop;